// The Reference Check tab's capture hotspots (CAPTURE.md H5: the offer.* prefix). Keys, never numbers.
import type { Hs } from "@/mc";

export const REF_HS = {
  requirement: "offer.ref.requirement",
  owner: "offer.ref.owner",
  provider: "offer.ref.provider",
  requested: "offer.ref.requested",
  completed: "offer.ref.completed",
  outcome: "offer.ref.outcome",
  notes: "offer.ref.notes",
  record: "offer.ref.record",
} as const satisfies Record<"requirement" | "owner" | "provider" | "requested" | "completed" | "outcome" | "notes" | "record", Hs>;
